import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function DevetLanding() {
  const nav = useNavigate();
  const { code } = useParams();

  useEffect(() => {
    const c = String(code || "").trim().toUpperCase();
    if (c) localStorage.setItem("cs_ref_code", c);
    nav("/couriersub/register", { replace: true });
  }, [code, nav]);

  return null;
}
